<template>
    <div id="app">
        <router-view />
        <depositPopup></depositPopup>
        <withdrawPopup></withdrawPopup>
        <bankSet></bankSet>
        <withdrawPwdSetPopup></withdrawPwdSetPopup>
        <loadingPopup></loadingPopup>
    </div>
</template>
<script>
import { getSysBaseConfig, telegramLogin } from '@/api/system'
import { getUserInfo } from '@/api/user'
// import { domain } from '@/common/http'
import { getPWAValue } from '@/api/pwa'
import { isPWA, getPlatform } from '@/utils'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
export default {
    created() {
        this.$i18n.locale = this.$store.getters.language
        const equipmentId = this.$store.state.system.equipmentId
        if (!equipmentId) this.getBrowserFingerprint()
    },
    mounted() {
        const that = this
        if (!this.$store.getters.invitCode && getPlatform() === 'ios' && isPWA()) this.getPWAValue()

        getSysBaseConfig().then((res) => {
            if (res.code) return
            const D = res.result
            this.$store.dispatch('system/setSysConfig', D)
            if (D.belongCountry && (!this.$store.state.system.userSetlanguage)) {
                this.$store.dispatch('system/setLanguage', D.belongCountry)
                this.$i18n.locale = D.belongCountry
            }
            try {
                const link = document.querySelector("link[rel*='icon']")
                if (link) link.href = D.homeImageUrl
                // document.querySelector('meta[property="og:title"]').setAttribute('content', D.projectName)
                // document.querySelector('meta[property="og:url"]').setAttribute('content', domain)
                // document.querySelector('meta[property="og:image"]').setAttribute('content', D.homeLogoUrl)
                // document.querySelector('meta[property="og:description"]').setAttribute('content', D.projectName)
            } catch (e) {
                console.log(e)
            }
        })
        try {
            const token = this.$store.getters.token
            if (token) {
                getUserInfo().then((uInfo) => {
                    if (uInfo.code) return
                    that.$websocket.initWebSocket()
                })
            } else {
                this.$websocket.close()
            }
        } catch (e) {
            console.log(e)
        }
        try {
            let isInstallPWA = 2
            if ('serviceWorker' in navigator) {
                window.addEventListener('beforeinstallprompt', function (e) {
                    // 阻止默认提示弹出
                    e.preventDefault()
                    that.$store.dispatch('system/setIsShowDownAppNav', 1)
                    that.$store.dispatch('system/setIsSaveVersionDesktop', 1)
                    isInstallPWA = 1
                    console.log('PWA未安装555555')
                })
                if (isInstallPWA === 2) {
                    console.log('PWA已经安装666666')
                    if (getPlatform() === 'ios') return
                    that.$store.dispatch('system/setIsShowDownAppNav', 2)
                    that.$store.dispatch('system/setIsSaveVersionDesktop', 2)
                }
            } else {
                console.log('Service Worker 不受此浏览器支持')
                // that.$store.dispatch('system/setIsShowDownAppNav', 1)
                that.$store.dispatch('system/setIsSaveVersionDesktop', 2)
            }
        } catch (e) {
            console.log(e, 'PWA错误')
        }
        window.addEventListener('beforeunload', this.handleBeforeUnload)

        that.telegramLogin()
    },
    beforeDestroy() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload)
    },
    methods: {
        handleBeforeUnload(event) {
            this.$websocket.close()
            console.log('浏览器即将关闭', event)
        },
        getPWAValue() {
            const that = this
            const userAgent = navigator.userAgent
            const params = { userAgent }
            getPWAValue(params).then((res) => {
                if (res.code) return
                const D = res.result
                that.$store.dispatch('user/setInvitCode', D.invitationCode)
                that.$store.dispatch('system/setPixel', D.trafficAcquisitionType)
                that.$store.dispatch('system/setTaId', D.taid)
                that.$store.dispatch('system/setClickId', D.clickId)
                that.$store.dispatch('user/setInvitCodeNum', 1)
                if (that.$store?.getters.invitCode && (!that.$store?.getters.token) && that.$store?.getters.invitCodeNum === 1) {
                    console.log(66666)
                    that.$store.dispatch('user/setInvitCodeNum', 2)
                    that.$store.dispatch('user/changeLoginType', 1)
                    that.$store.dispatch('user/setIsShowLoginPopup', true)
                }
            })
        },
        telegramLogin() {
            const WebApp = window.Telegram.WebApp
            WebApp.ready()
            const user = WebApp.initDataUnsafe.user
            if (user) {
                this.$store.commit('user/SET_TOKEN', '')
                const initData = WebApp.initData
                const params = JSON.stringify({ initData: initData })
                telegramLogin(params).then((res) => {
                    if (res?.code === 0) {
                        this.$store.dispatch('user/setInvitCode', '')
                        this.$store.dispatch('system/setTelegramUserId', '')
                        this.$store.commit('user/SET_TOKEN', `${res.result.tokenHead} ${res.result.token}`)
                        this.$forceUpdate()
                        getUserInfo().then((uInfo) => {
                            if (uInfo.code) return
                            this.$websocket.initWebSocket()
                        })
                        this.$store.dispatch('user/setIsShowLoginPopup', false)
                    }
                    if (res?.code === 401) {
                        this.$store.dispatch('system/setTelegramUserId', res.result.telegramUserId)
                    }
                })
            }
        },
        async getBrowserFingerprint() {
            let browserFinger
            try {
                const fp = await FingerprintJS.load()
                const result = await fp.get()
                browserFinger = result.visitorId
            } catch (error) {
                browserFinger = 'default123456789'
            }
            this.$store.dispatch('system/setEquipmentId', browserFinger)
        }
    }
}
</script>
<style lang="scss">
:root {
    --theme-bg-deep: #1b0b02;
    --theme-bg: #321503;
    --theme-surface: #4b2207;
    --theme-surface-soft: #61300b;
    --theme-gold: #ffd24a;
    --theme-orange: #ff8a00;
    --theme-orange-deep: #e95700;
    --theme-text: #fff8df;
    --theme-text-soft: #e8c991;
    --theme-border: rgba(255, 190, 76, .3);
    --theme-shadow: rgba(35, 12, 0, .34);
    --theme-surface-gradient: linear-gradient(180deg, rgba(102, 47, 7, .98) 0%, rgba(48, 18, 2, .99) 100%);
    --theme-surface-raised: linear-gradient(180deg, rgba(132, 67, 12, .98) 0%, rgba(67, 27, 3, .99) 100%);
    --theme-accent-gradient: linear-gradient(90deg, #ffd24a 0%, #ffad19 48%, #e95700 100%);
}

#app {
    font-family: "Segoe UI", Tahoma, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: var(--theme-text);
    min-height: 100vh;
    background-color: var(--theme-bg-deep);
    background-image:
        radial-gradient(circle at 50% -8%, rgba(255, 183, 45, .22) 0%, rgba(255, 138, 0, 0) 42%),
        linear-gradient(180deg, rgba(63, 25, 2, .18) 0%, rgba(24, 8, 0, .52) 100%),
        url("~@/assets/home/bg.png");
    background-size: cover, cover, cover;
    background-position: center top, center top, center top;
    background-repeat: no-repeat, no-repeat, no-repeat;
    background-blend-mode: screen, multiply, luminosity;
}

html[data-device-nodesktop="0"] {
    body {
        ::-webkit-scrollbar {
            display: none;
        }
    }
}

.global-toast {
    background: linear-gradient(90deg, var(--theme-gold), var(--theme-orange)) !important;
    border-radius: 12px !important;
    padding: 16px 24px !important;
    color: #321300 !important;
}
.global-toast .van-toast__text {
    color: #fff !important;
    font-size: 16px !important;
}

body {
    margin: 0 !important;
    background-color: var(--theme-bg-deep);
    background-image:
        radial-gradient(circle at 50% -8%, rgba(255, 183, 45, .22) 0%, rgba(255, 138, 0, 0) 42%),
        linear-gradient(180deg, rgba(63, 25, 2, .18) 0%, rgba(24, 8, 0, .52) 100%),
        url("~@/assets/home/bg.png");
    background-size: cover, cover, cover;
    background-position: center top, center top, center top;
    background-repeat: no-repeat, no-repeat, no-repeat;
    background-attachment: fixed;
    background-blend-mode: screen, multiply, luminosity;

    ::-webkit-scrollbar {
        width: .08rem;
        height: .06rem;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: .5rem;
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background-color: #666;
        // border: .05rem solid #0A0A0A;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
        border-radius: 5px;
        background-color: transparent;
    }

    .ant-input-affix-wrapper {
        width: 100%;
        height: 100%;
        border: none !important;
        background-color: transparent !important;
        color: #fff !important;

        // &:hover {
        //     .ant-input:not(.ant-input-disabled) {
        //         background-color: transparent !important;
        //         border: none !important;
        //     }
        // }

        // .ant-input:hover {
        //     background-color: transparent !important;
        //     border: none !important;
        // }

        .ant-input:focus {
            background-color: transparent !important;
            border: none !important;
            box-shadow: none;
        }

        .ant-input:active {
            background-color: transparent !important;
            border: none !important;
        }

        .ant-input {
            width: 100%;
            height: 100%;
            border: none;
            background-color: transparent !important;
            color: var(--theme-text) !important;
        }

        .ant-input-suffix {
            right: 0 !important;

            .ant-input-clear-icon {
                font-size: .29rem;
                color: var(--theme-text-soft);
            }
        }
    }

    .van-dialog,
    .van-picker,
    .van-action-sheet,
    .van-dropdown-menu__content,
    .van-calendar,
    .el-dialog,
    .popup-box,
    .popBox,
    .pop-box,
    .content-box,
    .list-box,
    .record-box,
    .info-box,
    .table-box,
    .bonusItem,
    .inviteTable,
    .share-content,
    .copy-content {
        background:
            linear-gradient(180deg, rgba(93, 43, 8, .98) 0%, rgba(50, 20, 3, .99) 100%) !important;
        color: var(--theme-text);
        border-color: var(--theme-border) !important;
        box-shadow: inset 0 1px 0 rgba(255, 230, 159, .1), 0 .08rem .18rem var(--theme-shadow);
    }

    .van-nav-bar,
    .van-nav-bar__content {
        background:
            linear-gradient(180deg, rgba(126, 63, 11, .96) 0%, rgba(67, 28, 4, .98) 100%) !important;
        color: var(--theme-text) !important;
    }

    .van-nav-bar .van-icon,
    .van-nav-bar__text,
    .van-nav-bar__title,
    .van-dropdown-menu__title {
        color: var(--theme-text) !important;
    }

    .van-cell,
    .van-field,
    .van-cell-group,
    .van-search,
    .van-search__content,
    .van-field__control,
    .el-input__inner,
    .ant-input,
    .ant-select-selector {
        background: rgba(42, 16, 2, .86) !important;
        color: var(--theme-text) !important;
        border-color: var(--theme-border) !important;
    }

    .van-cell::after,
    .van-hairline--top-bottom::after,
    .van-hairline-unset--top-bottom::after,
    .van-hairline--surround::after {
        border-color: rgba(255, 190, 76, .22) !important;
    }

    .van-button--default,
    .btn-default,
    .copyBtn,
    .btnCopy {
        background: linear-gradient(90deg, var(--theme-gold) 0%, #ffab16 48%, var(--theme-orange-deep) 100%) !important;
        color: #3b1700 !important;
        border-color: rgba(255, 218, 103, .56) !important;
        box-shadow: inset 0 1px 0 rgba(255, 249, 207, .42), 0 .04rem .12rem var(--theme-shadow);
    }

    .van-tabs__nav,
    .tabs,
    .tab-box {
        background: rgba(69, 29, 4, .78) !important;
        border-color: rgba(255, 190, 76, .24) !important;
    }

    .van-tab,
    .tab_item,
    .tabs .item {
        color: var(--theme-text-soft) !important;
    }

    .van-tab--active,
    .tab_item.act,
    .tabs .item.act {
        color: #fcfcfc !important;
        background: linear-gradient(90deg, var(--theme-gold) 0%, #ffad19 48%, var(--theme-orange-deep) 100%) !important;
        border-radius: .18rem;
    }

    .van-tabs__line {
        background: var(--theme-gold) !important;
    }

    .table-title,
    .inviteHead,
    .list-title,
    .head-title,
    .title-box {
        color: var(--theme-text) !important;
        background: rgba(104, 47, 7, .7) !important;
    }

    .inviteLine:nth-child(2n),
    .table-row:nth-child(2n),
    .list-item:nth-child(2n) {
        background: rgba(53, 21, 2, .58) !important;
    }

    .action_btn,
    .submit-btn,
    .login_btn,
    .sign_up,
    .userMoneyAdd,
    .sidebar_customerService,
    .btn-primary,
    .btn-submit,
    .btn-recharge,
    .btn-deposit,
    .btn-confirm {
        background: linear-gradient(90deg, var(--theme-gold) 0%, #ffad19 48%, var(--theme-orange-deep) 100%) !important;
        color: #3b1700 !important;
        border-color: rgba(255, 218, 103, .54) !important;
        box-shadow: inset 0 1px 0 rgba(255, 249, 207, .38), 0 .05rem .14rem var(--theme-shadow) !important;
    }

    .goTop,
    .floating-btn,
    .service_btn,
    .bonus-btn {
        background:
            radial-gradient(circle at 50% 0, rgba(255, 239, 160, .26) 0, rgba(255, 239, 160, 0) 34%),
            linear-gradient(180deg, rgba(255, 252, 222, .18) 0%, rgba(255, 252, 222, 0) .16rem),
            linear-gradient(180deg, rgba(255, 183, 31, .98) 0%, rgba(238, 104, 0, .98) 56%, rgba(139, 48, 0, .99) 100%) !important;
        color: #fff9e7 !important;
        border: 1px solid rgba(255, 220, 112, .5) !important;
        box-shadow:
            inset 0 1px 0 rgba(255, 252, 222, .22),
            0 0 .22rem rgba(255, 159, 24, .24),
            0 .06rem .14rem var(--theme-shadow) !important;
    }

    .btn-secondary,
    .toTransaction,
    .login,
    .withdraw_btn,
    .btn-withdraw {
        background: linear-gradient(180deg, rgba(126, 63, 11, .96) 0%, rgba(60, 24, 3, .99) 100%) !important;
        color: var(--theme-text) !important;
        border-color: var(--theme-border) !important;
    }

    .rulesDesc,
    .withdral_box,
    .page_input,
    .tab_content,
    .PaymentMethods-box,
    .DepositMethods-selected,
    .form_gap_item,
    .form_gap_item2_wrap,
    .providers_item,
    .game_item .gameName,
    .game_header > div:last-child > div:first-child {
        background:
            linear-gradient(180deg, rgba(255, 238, 189, .04) 0%, rgba(255, 238, 189, 0) .16rem),
            linear-gradient(180deg, rgba(73, 31, 5, .9) 0%, rgba(34, 12, 1, .94) 100%) !important;
        color: var(--theme-text) !important;
        border-color: rgba(255, 190, 76, .24) !important;
    }

    .van-nav-bar + *,
    .box-card,
    .record-item,
    .invite-item,
    .wallet-card,
    .vip-card,
    .notification-item,
    .history-item {
        border-color: rgba(255, 190, 76, .2) !important;
    }

    .tab__item.act,
    .WithdrawTypes__item.act,
    .DepositMethods-item.act,
    .form_gap_item.act,
    .form_gap_item2_wrap.active_gap_items2,
    .menu-item.act,
    .item.act {
        background: linear-gradient(90deg, rgba(255, 210, 74, .99) 0%, rgba(255, 158, 12, .98) 48%, rgba(233, 87, 0, .96) 100%) !important;
        color: #3b1700 !important;
        border-color: rgba(255, 219, 111, .58) !important;
        box-shadow: inset 0 1px 0 rgba(255, 249, 207, .24), 0 0 .14rem rgba(255, 145, 14, .2) !important;
    }

    .tips,
    .Recharge-Limt,
    .withdraw_rate,
    .input_title,
    .empty_txt,
    .noData,
    .moneyInfo-sub,
    .subTitle,
    .desc,
    .txt-sub {
        color: var(--theme-text-soft) !important;
    }

    .moneyInfo,
    .val,
    .num,
    .bankInput_txt,
    .bankInputNo,
    .exchangeRate_right,
    .RTP > span:last-child {
        color: var(--theme-text) !important;
    }
}

/* Unified amber shell and primary product surfaces. */
#app {
    .fixed-header,
    .pages-header {
        background:
            radial-gradient(circle at 18% 0, rgba(255, 222, 112, .18) 0, rgba(255, 222, 112, 0) 28%),
            linear-gradient(90deg, #5f2a06 0%, #7d3e09 36%, #572304 72%, #2e1001 100%) !important;
        border-color: rgba(255, 195, 79, .3) !important;
        box-shadow: inset 0 1px 0 rgba(255, 239, 188, .12), 0 .08rem .2rem rgba(32, 10, 0, .22) !important;
    }

    .icon_toggle,
    .deposit,
    .Notification.act {
        background:
            linear-gradient(180deg, rgba(255, 251, 218, .24) 0%, rgba(255, 251, 218, 0) 26%),
            var(--theme-accent-gradient) !important;
        color: #3b1700 !important;
        border-color: rgba(255, 225, 128, .56) !important;
        box-shadow: inset 0 1px 0 rgba(255, 249, 207, .3), 0 .05rem .14rem rgba(65, 22, 0, .22) !important;
    }

    .down_box,
    .search_btn,
    .user_info_pc,
    .user_info,
    .Notification,
    .sidebar_lang,
    .userMoneyItem {
        background:
            linear-gradient(180deg, rgba(255, 238, 189, .08) 0%, rgba(255, 238, 189, 0) .16rem),
            var(--theme-surface-gradient) !important;
        color: var(--theme-text) !important;
        border-color: var(--theme-border) !important;
        box-shadow: inset 0 1px 0 rgba(255, 238, 189, .1), 0 .06rem .16rem var(--theme-shadow) !important;
    }

    .down_box .down_img {
        background: linear-gradient(180deg, #321302 0%, #180800 100%) !important;
        border-color: rgba(255, 190, 76, .2) !important;
    }

    .down_info > div:first-child,
    .search_btn .txt,
    .user_info_pc,
    .Notification,
    .user_money {
        color: var(--theme-text) !important;
    }

    .down_info > div:last-child,
    .user_info_pc .u-info > div:last-child {
        color: var(--theme-text-soft) !important;
    }

    .Opend {
        background:
            radial-gradient(circle at 20% 0, rgba(255, 212, 89, .2) 0, rgba(255, 212, 89, 0) 28%),
            linear-gradient(180deg, #6e3007 0%, #4d1e03 24%, #321102 58%, #1c0800 100%) !important;
        border-color: rgba(255, 190, 76, .28) !important;
        box-shadow: inset -1px 0 0 rgba(255, 215, 116, .1), .08rem 0 .24rem rgba(25, 7, 0, .24) !important;
    }

    .share_box {
        background:
            radial-gradient(circle at 12% 0, rgba(255, 241, 173, .3) 0, rgba(255, 241, 173, 0) 34%),
            linear-gradient(110deg, rgba(255, 196, 55, .28) 0%, rgba(255, 128, 0, .3) 48%, rgba(126, 45, 0, .98) 100%) !important;
        border-color: rgba(255, 215, 108, .5) !important;
        box-shadow: inset 0 1px 0 rgba(255, 246, 204, .18), 0 .1rem .22rem var(--theme-shadow) !important;
    }

    .Opend_bottom,
    .menu-item,
    .game .box,
    .game .game-classify,
    .game-classify .item,
    .game-classify .game-classify-nav,
    .notice,
    .money_box,
    .contaItem,
    .menus-item {
        background:
            linear-gradient(180deg, rgba(255, 238, 189, .08) 0%, rgba(255, 238, 189, 0) .14rem),
            var(--theme-surface-gradient) !important;
        color: var(--theme-text) !important;
        border-color: var(--theme-border) !important;
        box-shadow: inset 0 1px 0 rgba(255, 238, 189, .1), 0 .06rem .16rem var(--theme-shadow) !important;
    }

    .menu-item:hover,
    .game-classify .item:hover,
    .game-classify .item.act {
        background:
            linear-gradient(180deg, rgba(255, 252, 220, .26) 0%, rgba(255, 252, 220, 0) 28%),
            var(--theme-accent-gradient) !important;
        color: #3b1700 !important;
        border-color: rgba(255, 225, 128, .58) !important;
        box-shadow: inset 0 1px 0 rgba(255, 249, 207, .3), 0 0 .18rem rgba(255, 145, 14, .22) !important;
    }

    .game-classify .item .name,
    .game-classify .game-classify-nav,
    .game_header,
    .game_header .name,
    .game_header .more,
    .pages-content {
        color: var(--theme-text) !important;
        text-shadow: 0 1px 0 rgba(49, 15, 0, .46) !important;
    }

    .game-classify .item.act .name,
    .game-classify .item:hover .name {
        color: #3b1700 !important;
        text-shadow: none !important;
    }

    .game-classify .item .icon img {
        filter: drop-shadow(0 .04rem .08rem rgba(255, 174, 31, .26)) brightness(1.12) saturate(1.1) !important;
    }

    .game_item,
    .providers_item {
        background: linear-gradient(180deg, rgba(55, 23, 4, .98) 0%, rgba(27, 9, 1, .99) 100%) !important;
        border-color: rgba(255, 190, 76, .22) !important;
        box-shadow: inset 0 1px 0 rgba(255, 230, 159, .06), 0 .08rem .18rem rgba(26, 8, 0, .24) !important;
    }

    .game_info,
    .gameName,
    .img_placeholder,
    .img_fallback {
        background:
            linear-gradient(180deg, rgba(255, 231, 172, .06) 0%, rgba(255, 231, 172, 0) .12rem),
            linear-gradient(180deg, rgba(67, 29, 5, .98) 0%, rgba(34, 12, 1, .99) 100%) !important;
        color: var(--theme-text) !important;
        border-color: rgba(255, 190, 76, .18) !important;
    }

    .tabbar {
        background:
            radial-gradient(circle at 50% 0, rgba(255, 214, 96, .18) 0, rgba(255, 214, 96, 0) 46%),
            linear-gradient(180deg, rgba(91, 39, 5, .99) 0%, rgba(35, 12, 1, .99) 100%) !important;
        border-color: rgba(255, 190, 76, .3) !important;
    }

    .tabbar .item .van-icon,
    .tabbar .item .item-text {
        color: var(--theme-text-soft) !important;
    }

    .tabbar .item.act .van-icon,
    .tabbar .item.act .item-text {
        color: var(--theme-gold) !important;
        filter: drop-shadow(0 0 .08rem rgba(255, 162, 20, .42));
    }

    .van-overlay {
        background: rgba(28, 8, 0, .72) !important;
        backdrop-filter: blur(3px);
    }

    .van-popup .van-field,
    .van-popup .van-cell {
        background: rgba(42, 15, 1, .82) !important;
        color: var(--theme-text) !important;
        border-color: rgba(255, 190, 76, .24) !important;
    }

    .van-popup .tab-item,
    .van-popup .btn,
    .van-popup .ant-btn-primary {
        background: var(--theme-surface-raised) !important;
        color: var(--theme-text) !important;
        border-color: rgba(255, 190, 76, .3) !important;
    }

    .van-popup .tab-item.act,
    .van-popup .btn-bonus,
    .van-popup .ant-btn-primary {
        background:
            linear-gradient(180deg, rgba(255, 252, 220, .24) 0%, rgba(255, 252, 220, 0) 26%),
            var(--theme-accent-gradient) !important;
        color: #3b1700 !important;
        border-color: rgba(255, 225, 128, .56) !important;
        box-shadow: inset 0 1px 0 rgba(255, 249, 207, .28), 0 .06rem .16rem rgba(55, 18, 0, .24) !important;
    }

    .pages:has(> .user_info > .money_box) {
        background:
            radial-gradient(circle at 50% -5%, rgba(255, 190, 54, .18) 0, rgba(255, 190, 54, 0) 42%),
            linear-gradient(180deg, rgba(53, 19, 1, .96) 0%, rgba(25, 8, 0, 1) 100%) !important;
    }

    // .swipe {
    //     border: 1px solid rgba(255, 187, 65, .24);
    //     box-shadow: 0 .08rem .2rem rgba(34, 10, 0, .24);
    // }

    .swipe .van-swipe-item {
        position: relative;
    }

    .swipe .van-swipe-item::after {
        content: "";
        position: absolute;
        inset: 0;
        z-index: 2;
        pointer-events: none;
        background: #ff8a00;
        border-radius: .2rem !important;
        overflow: hidden;
        mix-blend-mode: hue;
        opacity: .48;
    }

    ::selection {
        background: rgba(255, 174, 25, .68);
        color: #2d1000;
    }
}
</style>
